import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Analytics from "js/analytics";
import { Button } from "js/Components/Button";
import { getStaticUrl } from "js/config";
import { BeautifulDialog, ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { Gap10 } from "js/react/components/Gap";
import { themeColors } from "js/react/sharedStyles";

import { DialogActions, DialogBody, DialogContent, DialogTitle, UpgradeToRestoreSection } from "./components/DialogComponents";

function TrialCanceledDialog(props: { onClose: () => void }) {
    const { onClose } = props;
    const { t } = useTranslation();

    useEffect(() => {
        Analytics.Dunning.TrialCanceledDialogOpened();
    }, []);

    const handleUpgrade = async () => {
        Analytics.Dunning.TrialCanceledDialogUpgradeClicked();

        // @ts-ignore
        const { default: ChangePlanDialog } = await import("js/react/components/Dialogs/ChangePlanDialog");
        ShowDialog(ChangePlanDialog, {
            analytics: { cta: "trial_canceled_dialog_upgrade" }
        });

        onClose();
    };

    const handleContinueOnBasic = async () => {
        Analytics.Dunning.TrialCanceledDialogDismissed();
        onClose();
    };

    return (
        <BeautifulDialog preventClose>
            <DialogBody>
                <DialogTitle>
                    <img src={getStaticUrl("/images/beautifulai-logos/beautifulai-upgrade-logo.svg")} />
                    <Gap10 />
                    <div>{t("Your trial has ended")}</div>
                    <p>{t("Your presentations and content are right where you left them. Upgrade anytime to restore premium features.")}</p>
                </DialogTitle>
                <DialogContent>
                    <UpgradeToRestoreSection />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleContinueOnBasic} large color={themeColors.lightGray} style={{ color: "#666" }}>
                        {t("Continue on Basic")}
                    </Button>
                    <Button upgrade large onClick={handleUpgrade}>
                        {t("Upgrade")}
                    </Button>
                </DialogActions>
            </DialogBody>
        </BeautifulDialog>
    );
}

export default TrialCanceledDialog;
